export const WIZARD_MESSAGES = {
    CANCEL_WARNING: () =>
        `Cancelling this wizard will lead to loss of all changes. Are you sure you wish to continue?`,
};
